import React from 'react';
import BasicModal from './BasicModal';
import { faDiamondExclamation, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import MyAppText from './MyAppText';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import FontWeight from '../styles/fontWeights';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    title: string;
    /**
     * The default value should be the title
     */
    customButtonLabel?: string;
    type: 'destructive' | 'warning';
    description: string | React.JSX.Element;
    /**
     * you can return `false` if you want the modal to keep open
     */
    onSubmit: (() => void | false) | (() => Promise<void | false>);
}

export default function AlertModal({
    isModalVisible,
    setModalVisible,
    title,
    type,
    description,
    onSubmit,
    customButtonLabel,
}: ModalProps) {
    const { styles } = useStyles(styleSheet);

    return <BasicModal
        isModalVisible={isModalVisible}
        setModalVisible={setModalVisible}
        width='small'
        mobileHeight='fit'
        title={title}
        titleIcon={type === 'destructive' ? faDiamondExclamation : faTriangleExclamation}
        type={type}
        primaryButton={{ text: customButtonLabel ?? title, onClick: onSubmit }}
    >
        <MyAppText style={styles.description}>{description}</MyAppText>
    </BasicModal>;
}

const styleSheet = createStyleSheet((theme) => ({
    description: {
        color: theme.colors.neutral[400],
        fontWeight: FontWeight.medium,
        fontSize: 16,
    },
}));
